<p>payment-redirect works!</p>
